export default function DartsIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <circle cx="30" cy="34" r="27" fill="#151515" />
      <circle cx="30" cy="34" r="23" fill="#d8282e" />
      <circle cx="30" cy="34" r="20" fill="#f2e6c9" />
      <circle cx="30" cy="34" r="14" fill="#1e8f4a" />
      <circle cx="30" cy="34" r="11" fill="#151515" />
      <circle cx="30" cy="34" r="5" fill="#1e8f4a" />
      <circle cx="30" cy="34" r="2.5" fill="#d8282e" />
      <path d="M31 33L50 14" stroke="#c9ced8" strokeWidth="3" strokeLinecap="round" />
      <path d="M42 22L52 12" stroke="#5b6170" strokeWidth="5" strokeLinecap="round" />
      <path d="M50 14l4-10 2 8 8 2-10 4z" fill="#2F8BFF" />
    </svg>
  );
}
